module.exports = __webpack_public_path__ + "static/media/31.434d147c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/31.png
// module id = 1138
// module chunks = 0